import { inject, singleton } from "tsyringe";
import { COOKIES, WINDOW } from "@identity/symbols";
import { TopLevelDomainExtractor } from "@identity/utils";

export enum USP_VALUES {
  yes = "Y",
  no = "N",
  na = "-",
}

@singleton()
export class UsPrivacy {
  private readonly usPrivacyCookie = "usprivacy";
  private readonly USP_API_VERSION = 1;
  private readonly explicitNotice = USP_VALUES.yes;
  private readonly lspaSupport = USP_VALUES.no;

  constructor(
    @inject(WINDOW) private readonly window: Window,
    @inject(COOKIES) private readonly cookiesManager: CookiesManager,
  ) {}

  createPrivacyCookie(optOut = USP_VALUES.na) {
    const domain = TopLevelDomainExtractor.extract(
      this.window.location.hostname,
    );
    const usPrivacy =
      optOut === USP_VALUES.na
        ? `${this.USP_API_VERSION}${USP_VALUES.na}${USP_VALUES.na}${USP_VALUES.na}`
        : `${this.USP_API_VERSION}${this.explicitNotice}${optOut}${this.lspaSupport}`;
    this.cookiesManager.set(this.usPrivacyCookie, usPrivacy, {
      domain,
      sameSite: "Lax",
      expires: 365,
    });
  }

  getPrivacyString(): string | undefined {
    return this.cookiesManager.get(this.usPrivacyCookie);
  }
}
